import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import constant from '../../constant'
import { getProfileImage, getStorage } from '../../utils';
import logo from './../../assets/images/logo.png';
import khaliimage from "../../assets/images/Default-company-logo (3).png";
import khaliimagee from "../../assets/images/bulding-images.png";

export default class HeaderAfterLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            profileImage: null,
            userType: null,
            details: getStorage(constant.keys.userDetails),


        }
    }
    componentDidMount() {
        getProfileImage().then(res => {
            if (res.status) {
                this.setState({ profileImage: res.result.fileName, userType: res.result.USER_TYPE })
            }
        })
    }
    render() {
        const topmenudro = {
            left: "-200px"
        };
        const { details, profileImage, userType } = this.state;
        return (

            <header className="header-area header-desktop">
                <div className="header-menu-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="menu-full-width">
                                    <div className="logo">
                                        <Link to='/'><img src={logo} alt="logo" /></Link>
                                    </div>
                                    <div className="main-menu-content">
                                        <nav>
                                            <ul>
                                                <li>
                                                    <Link to='/'>Home</Link>
                                                </li>
                                                <li>
                                                    <a >Product & Services <i className="la la-angle-down"></i></a>
                                                    <ul className="dropdown-menu-item">
                                                        {details.USER_TYPE === 'EMPLOYER' && <li><a href={constant.component.JobPackage.url}>Subscriptions</a></li>}
                                                        <li><a id='linked-in' href={constant.component.JobPosting.url}>Job Posting</a></li>
                                                        <li><a id='linked-in' target="_blank" href="javascript:void(0)">CRM</a></li>
                                                        <li><a id='linked-in' target="_blank" href="javascript:void(0)">Corporate Training</a></li>
                                                        <li><a id='linked-in' target="_blank" href="javascript:void(0)">Campus Hiring</a></li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                    <div className="logo-right-content">
                                        <div className="header-action-button d-flex align-items-center">
                                            <div className="user-action-wrap">
                                                <div className="notification-item">
                                                    <div className="dropdown">
                                                        <button className="notification-btn dropdown-toggle" type="button" id="userDropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                            <span className='la la-bars'></span>  {profileImage ? <img src={profileImage ? `${process.env.REACT_APP_BASE_URL}/company/logo/${profileImage}` : logo} alt="My Profile" /> :

                                                                <img
                                                                    src={khaliimagee}
                                                                    style={{
                                                                        width: "40px",
                                                                        height: "40px",

                                                                        objectFit: "contain",
                                                                        marginBottom: "1px"
                                                                    }}
                                                                />


                                                            }
                                                        </button>
                                                        <div className="dropdown-menu" aria-labelledby="userDropdownMenu" style={topmenudro}>
                                                            <div className="mess-dropdown">
                                                                <div className="mess__title d-flex align-items-center">
                                                                    <div className="image dot-status online-status">
                                                                        <a href="#">
                                                                            {profileImage ? <img src={profileImage ? `${process.env.REACT_APP_BASE_URL}/company/logo/${profileImage}` : logo} alt={details.COMPANY_NAME} /> : <div>

                                                                                <img
                                                                                    src={khaliimage}
                                                                                    style={{
                                                                                        width: "50px",
                                                                                        height: "auto",
                                                                                        objectFit: "contain",
                                                                                        marginTop: "10px",
                                                                                    }}
                                                                                />


                                                                            </div>}
                                                                        </a>
                                                                    </div>
                                                                    <div className="content">
                                                                        <h4 className="widget-title font-size-14">
                                                                            <a href="#">{details.COMPANY_NAME}</a>
                                                                        </h4>
                                                                        <p style={{ wordBreak: "break-all", lineHeight: "17px" }} className="email">{details.EMAIL}</p>
                                                                    </div>
                                                                </div>
                                                                <div className="mess__body">
                                                                    <ul className="list-items">
                                                                     
                                                                        <li className="mb-0">
                                                                            <Link to={constant.component.viewProfile.url} className="d-block">
                                                                                <i className="la la-user"></i> View Profile
                                                                            </Link>
                                                                        </li>
                                                                        <li className="mb-0">
                                                                            <div className="section-block mt-1 mb-1"></div>
                                                                        </li>
                                                                        {userType === 'EMPLOYER' && <li className="mb-0">
                                                                            <Link to={constant.component.EditProfile.url} className="d-block">
                                                                                <i className="la la-edit"></i> Edit Profile
                                                                            </Link>
                                                                        </li>}
                                                                        <li className="mb-0">
                                                                            <div className="section-block mt-1 mb-1"></div>
                                                                        </li>
                                                                        <li className="mb-0">
                                                                            <Link to={constant.component.PostARegularJob.url} className="d-block">
                                                                                <i className="la la-bookmark"></i> Post A Job
                                                                            </Link>
                                                                        </li>
                                                                        <li className="mb-0">
                                                                            <div className="section-block mt-1 mb-1"></div>
                                                                        </li>
                                                                        
                                                                        <li className="mb-0">
                                                                            <div className="section-block mt-1 mb-1"></div>
                                                                        </li>
                                                                        <li className="mb-0">
                                                                            <a href="javascript:void(0)" className="d-block">
                                                                                <i className="la la-question"></i> Help
                                                                            </a>
                                                                        </li>
                                                                        <li className="mb-0">
                                                                            <div className="section-block mt-1 mb-1"></div>
                                                                        </li>
                                                                        <li className="mb-0">
                                                                            <Link to={constant.component.Settings.url} className="d-block">
                                                                                <i className="la la-gear"></i> Settings
                                                                            </Link>
                                                                        </li>
                                                                        <li className="mb-0">
                                                                            <div className="section-block mt-2 mb-2"></div>
                                                                        </li>
                                                                        <li className="mb-0">
                                                                            <a href={constant.component.logout.url} className="d-block">
                                                                                <i className="la la-power-off"></i> Logout
                                                                            </a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="menu-toggler d-flex align-items-center">
                                            <div className="side-menu-open">
                                                <span className="menu__bar"></span>
                                                <span className="menu__bar"></span>
                                                <span className="menu__bar"></span>
                                            </div>
                                           
                                            <div className="user-action-wrap mobile-profile">
                                                <div className="notification-item">
                                                    <div className="dropdown">
                                                        <button className="notification-btn dropdown-toggle" type="button" id="userDropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                            {profileImage ? <img src={profileImage ? `${process.env.REACT_APP_BASE_URL}/company/logo/${profileImage}` : logo} alt="My Profile" /> : <div>

                                                                <img
                                                                    src={khaliimagee}
                                                                    style={{
                                                                        width: "40px",
                                                                        height: "40px",

                                                                        objectFit: "contain",
                                                                        marginBottom: "1px"
                                                                    }}
                                                                />


                                                            </div>}
                                                        </button>
                                                        <div className="dropdown-menu" aria-labelledby="userDropdownMenu" style={topmenudro}>
                                                            <div className="mess-dropdown">
                                                                <div className="mess__title d-flex align-items-center">
                                                                    <div className="image dot-status online-status">
                                                                        <a href="#">
                                                                            {profileImage ? <img src={profileImage ? `${process.env.REACT_APP_BASE_URL}/company/logo/${profileImage}` : logo} alt={details.COMPANY_NAME} /> : <div>

                                                                                <img
                                                                                    src={khaliimage}
                                                                                    style={{
                                                                                        width: "50px",
                                                                                        height: "auto",
                                                                                        objectFit: "contain",
                                                                                        marginTop: "10px",
                                                                                    }}
                                                                                />


                                                                            </div>}
                                                                        </a>
                                                                    </div>
                                                                    <div className="content">
                                                                        <h4 className="widget-title font-size-14">
                                                                            <a href="#">{details.COMPANY_NAME}</a>
                                                                        </h4>
                                                                        <p style={{ wordBreak: "break-all", lineHeight: "17px" }} className="email">{details.EMAIL}</p>
                                                                    </div>
                                                                </div>
                                                                <div className="mess__body">
                                                                    <ul className="list-items">
                                                                        <li className="mb-0">
                                                                            <Link to={constant.component.viewProfile.url} className="d-block">
                                                                                <i className="la la-user"></i> View Profile
                                                                            </Link>
                                                                        </li>
                                                                        <li className="mb-0">
                                                                            <Link to={constant.component.EditProfile.url} className="d-block">
                                                                                <i className="la la-edit"></i> Edit Profile
                                                                            </Link>
                                                                        </li>
                                                                        <li className="mb-0">
                                                                            <Link to={constant.component.PostARegularJob.url} className="d-block">
                                                                                <i className="la la-bookmark"></i> Post A Job
                                                                            </Link>
                                                                        </li>
                                                                        <li className="mb-0">
                                                                            <a href="javascript:void(0)" className="d-block">
                                                                                <i className="la la-question"></i> Help
                                                                            </a>
                                                                        </li>
                                                                        <li className="mb-0">
                                                                            <Link to={constant.component.Settings.url} className="d-block">
                                                                                <i className="la la-gear"></i> Settings
                                                                            </Link>
                                                                        </li>
                                                                        <li className="mb-0">
                                                                            <div className="section-block mt-2 mb-2"></div>
                                                                        </li>
                                                                        <li className="mb-0">
                                                                            <a href={constant.component.logout.url} className="d-block">
                                                                                <i className="la la-power-off"></i> Logout
                                                                            </a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}
